if (import.meta.hot) {
    import.meta.hot.accept()
}

if (document.querySelector('[name=form_busca]') && !/imovel/.exec(location.pathname)) {
    import('./busca')
}

